import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar, Checkbox } from "@mui/material";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import SearchComponent from "../../../components/SearchComponent";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";
import "./CreateTaskModal.css";
import CompDirection from "../../../themes/CompDirection";
import { fonts } from "../../../themes/themes";
import DropAndSelect from "../../../components/DropAndSelect/DropAndSelect";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;

  trans?: any;
}

const CreateTaskModalPresenter = ({
  isModalOpen,
  closeModal,

  trans,
}: ModalProps) => {
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="75vh"
      modalWidth="40vw"
      overflowY={"auto"}
    >
      <ModalHeader
        modal={{ modal_title: trans("Create New Task") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          spacing={2}
          container
          sx={{
            marginTop: "15px",
          }}
        >
          <Grid item xs={6}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "1em",
                borderRadius: "7px",
              }}
            >
              <CustomTextField type="string" label="Task Title" />
              <Box marginTop={"1em"} />
              <CustomTextField
                type="string"
                label="Description"
                multiline={true}
                rows={3}
              />
              <Box marginTop={"1em"} />

              <CustomAutoComplete label="Set Priority" value="Low" />
              <Box marginTop={"1em"} />
              <CustomDatePicker label="Start From" />
              <Box marginTop={"1em"} />
              <CustomDatePicker label="Due Date" />
              <Box marginTop={"1em"} />
              <DropAndSelect
                upload={() => alert()}
                src={""}
                isPDF={false}
                pdfName={""}
                onDelete={() => {
                  alert("");
                  alert(false);
                  alert("");
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "1em",
                borderRadius: "7px",
              }}
            >
              <Typography
                style={{
                  color: "#575757",
                  fontFamily: fonts.fontFamily,
                  fontSize: "0.725em",
                  fontWeight: "bold",
                }}
              >
                Members(2)
              </Typography>
              <Box marginTop={"1em"} />
              <Box style={{ display: "flex" }}>
                <Avatar />
                <Avatar />
                <Box className="add_btn_perf" onClick={() => console.log()}>
                  {" "}
                  <i className="las la-plus" style={{ color: "white" }} />{" "}
                </Box>
              </Box>
              <Box marginTop={"1em"} />
              <CustomDatePicker label="Start From" />
              <Box marginTop={"1em"} />
              <CustomDatePicker label="Due Date" />
              <Box marginTop={"1em"} />
              <CustomAutoComplete label="Set Priority" value="Low" />
            </Box>
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default CreateTaskModalPresenter;
